import React from 'react';
export const content = (
  <p>
    A new puppy coming home for the first time is an exciting time for every pet parent but can also
    be overwhelming. That’s why Chewy has pulled together this guide with expert advice for puppy
    parents. Your puppy guide is full of information ranging from vet visits, dental care, and
    grooming to training, puppy-proofing, and nutrition. This guide is here to help you support your
    puppy’s overall health and well-being during their first year.
  </p>
);
